module.exports = __webpack_public_path__ + "static/media/avatar.f1d71f77.jpg";